import { LegacySensor, SensorMeta, fetchSensorAPI, rootApiUrl } from "../jefdaqLegacyAPI";

export interface PrecipApiSensor extends LegacySensor {
  site: string;
  lastReport: string;
  latitude: number;
  longitude: number;
  name: string;
  source: string;
  null: number;
  precipitationDepthsInches: number[];
  unitShort: string;
}

export interface PrecipApiMeta extends SensorMeta {
  precipitationIntervalSeconds: number[];
  timezone: string;
}

export interface PrecipApiResponse {
  meta: PrecipApiMeta;
  data: PrecipApiSensor[];
}

const url = rootApiUrl + "/json/rainfall/"
const check = /inch(es)?/i;

export const fetchPrecipAPI = () => fetchSensorAPI<PrecipApiMeta, PrecipApiSensor>(url,check);
